module.exports = __webpack_public_path__ + "img/GreekTechConscription_ua.7cda501f.webp";